import React from 'react';
import EntityLoader from './LoadingEntity.component';
import {
  SkeletonContainer,
  SkeletonContent,
  SkeletonLeft,
  SkeletonRight,
  SkeletonBreadcrumbs,
  SkeletonButton,
  SkeletonHeader,
} from './LoadingCourse.component';

const LoadingQuizPage = () => {
  return (
    <SkeletonContainer>
      <SkeletonContent>
        <SkeletonRight>
          <SkeletonBreadcrumbs />
          <SkeletonBreadcrumbs />
          <SkeletonBreadcrumbs />
          <SkeletonButton />
        </SkeletonRight>
        <SkeletonLeft>
          <SkeletonHeader />
          <EntityLoader />
        </SkeletonLeft>
      </SkeletonContent>
    </SkeletonContainer>
  );
};

export default LoadingQuizPage;
